import { useAuthAxiosConfigEffect } from './useAuthAxiosConfigEffect';
/**
 * This will now be the place we aggregate any items that need called to connect
 * our API implementations to the auth context.
 */
export const MsrcApiConfigConnector = ({ enableAxios = true, enableOData = true, }) => {
    useAuthAxiosConfigEffect(enableAxios || enableOData);
    //TODO: Add GraphQL connector here.
    return null;
};
